export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" fill="#0A0A0B" />
    <path d="M8 10h48v12H38v32H26V22H8z" fill="#00FF66" />
    <rect x="42" y="30" width="3" height="24" fill="#FAFAFA" />
    <rect x="47.5" y="30" width="3" height="24" fill="#FAFAFA" />
    <rect x="53" y="30" width="3" height="24" fill="#FAFAFA" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark className="h-8 w-8 border border-white/15" />
    <span className="font-display text-2xl font-black uppercase leading-none tracking-tight">T Brand</span>
  </span>
);
